import { toBcp47 } from '../i18n/index.jsx';

/**
 * SB-9141 — primary language subtags written right-to-left. `iw` is the
 * legacy code for Hebrew that some systems still emit.
 */
const RTL_LANGUAGES = new Set(['ar', 'he', 'iw', 'fa', 'ur', 'ps', 'sd', 'ug', 'yi', 'dv', 'ckb']);

/**
 * Canonical Sessionboard locale ('ar', 'he_IL', 'fa-IR') → 'rtl' | 'ltr'.
 * @param {string | null | undefined} locale
 * @returns {'rtl' | 'ltr'}
 */
export const textDirection = (locale) => {
  if (!locale || typeof locale !== 'string') return 'ltr';
  const primary = locale.trim().replace(/_/g, '-').split('-')[0].toLowerCase();
  return RTL_LANGUAGES.has(primary) ? 'rtl' : 'ltr';
};

/**
 * Sets `dir` and `lang` on the widget's root container so the layout mirrors
 * for an RTL locale. The widget's CSS uses logical properties, so `dir` is
 * all it takes. With no locale yet the attributes are removed and the
 * container inherits from the host page.
 *
 * @param {HTMLElement | null | undefined} container
 * @param {string | null | undefined} locale
 */
export const applyLocaleDirection = (container, locale) => {
  if (!container) return;
  if (!locale) {
    container.removeAttribute('dir');
    container.removeAttribute('lang');
    return;
  }
  container.setAttribute('dir', textDirection(locale));
  container.setAttribute('lang', toBcp47(locale));
};
